module.exports = "/assets/43744e4016adb455731628ecfe675694.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/SP.png
// module id = 1829
// module chunks = 0